import request from '../request'
import { useMutation } from 'react-query'

export const useDeleteTwoFactorAuthentication = () => {
  return useMutation(({ type }: { type: 'sms' | 'authenticator' }) =>
    request({
      url: `/auth/two-factor/${type}`,
      method: 'DELETE',
    }),
  )
}
